// import React, { useEffect, useState } from "react";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
// } from "react-router-dom";
// import Signup from "./Signup";
// import Login from "./Login";
// import Dashboard from "./Dashboard";
// import Profile from "./Profile";
// import { auth } from "./firebase";
// import { onAuthStateChanged } from "firebase/auth";
// import CreateTransaction from "./CreateTransaction";
// import Wallet from "./Wallet";

// const App = () => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         setIsAuthenticated(true);
//       } else {
//         setIsAuthenticated(false);
//       }
//       setLoading(false);
//     });

//     return () => unsubscribe();
//   }, []);

//   if (loading) {
//     return <div className="loader"></div>;
//   }

//   return (
//     <Router>
//       <Routes>
//         <Route
//           path="/"
//           element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />}
//         />
//         <Route path="/signup" element={<Signup />} />
//         <Route
//           path="/dashboard"
//           element={isAuthenticated ? <Dashboard /> : <Navigate to="/" />}
//         />
//         <Route
//           path="/profile"
//           element={isAuthenticated ? <Profile /> : <Navigate to="/" />}
//         />
//         <Route
//           path="/CreateTransaction"
//           element={
//             isAuthenticated ? <CreateTransaction /> : <Navigate to="/" />
//           }
//         />
//         <Route
//           path="/Wallet"
//           element={isAuthenticated ? <Wallet /> : <Navigate to="/" />}
//         />
//       </Routes>
//     </Router>
//   );
// };

// export default App;

import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Signup from "./Signup";
import Login from "./Login";
import Dashboard from "./Dashboard";
import Profile from "./Profile";
import CreateTransaction from "./CreateTransaction";
import Wallet from "./Wallet";
import Onboarding from "./Onboarding";
import VerifyPin from "./VerifyPin";
import { auth } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import TransferSuccess from "./TransferSuccess";
import RecentActivities from "./RecentActivities";
import VerifyPinn from "./VerifyPinTransfer";

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [onboardingComplete, setOnboardingComplete] = useState(
    localStorage.getItem("onboardingComplete") === "true"
  );

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div className="loader">Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            onboardingComplete ? (
              isAuthenticated ? (
                <Navigate to="/verify-pin" />
              ) : (
                <Navigate to="/login" />
              )
            ) : (
              <Onboarding />
            )
          }
        />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/signup" element={<Signup />} />
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/verify-pin" /> : <Login />}
        />

        <Route path="/recent-activities" element={<RecentActivities />} />
        <Route
          path="/dashboard"
          element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />}
        />
        <Route path="/transfer-success" element={<TransferSuccess />} />
        <Route
          path="/profile"
          element={isAuthenticated ? <Profile /> : <Navigate to="/login" />}
        />
        <Route
          path="/CreateTransaction"
          element={
            isAuthenticated ? <CreateTransaction /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/wallet"
          element={isAuthenticated ? <Wallet /> : <Navigate to="/login" />}
        />

        <Route path="/verify-pinn" element={<VerifyPinn />} />

        <Route
          path="/verify-pin"
          element={isAuthenticated ? <VerifyPin /> : <Navigate to="/login" />}
        />
      </Routes>
    </Router>
  );
};

export default App;
